import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SupportedBrowsersResponse } from './../../../core/model/supported-browsers-response.model';

@Component({
  selector: 'app-unsupported-browser',
  templateUrl: './unsupported-browser.component.html',
  styleUrls: ['./unsupported-browser.component.scss']
})
export class UnsupportedBrowserComponent {

  supportBrowsersResp: SupportedBrowsersResponse;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<UnsupportedBrowserComponent>
  ) {
    this.supportBrowsersResp = data;
  }
  Close(){
    this.dialogRef.close();
  }
}
